import axios from "axios";
import { jwtClient } from "./authUtils";

export const REQUEST_REGION = "REQUEST_REGION";
const requestRegion = () => {
  return {
    type: REQUEST_REGION,
  };
};

export const RECEIVE_REGION = "RECEIVE_REGION";
const receiveRegion = (region, regionData) => {
  return {
    type: RECEIVE_REGION,
    region,
    regionData,
  };
};

export const FAILED_REGION = "FAILED_REGION";
const failedRegion = () => {
  return {
    type: FAILED_REGION,
  };
};

export const fetchRegion = (apiUrl, regionId) => {
  return async (dispatch) => {
    dispatch(requestRegion());
    try {
      var url =
        apiUrl +
        "/api/forecast/list/:id/?format=json".replace(":id", regionId) +
        "&no_forecast=true";
      var dataUrl = apiUrl + "/api/forecast/list/:id/?format=json".replace(":id", regionId);

      const response = await jwtClient.withJWT(async (jwt) => {
        return Promise.all([
          axios.get(url, {
            headers: { Authorization: "JWT " + jwt },
          }),
          axios.get(dataUrl, {
            headers: { Authorization: "JWT " + jwt },
          }),
        ]);
      });

      return dispatch(receiveRegion(response[0].data, response[1].data));
    } catch (err) {
      console.log(err);
      return dispatch(failedRegion());
    }
  };
};

const weatherRegionActions = {
  fetchRegion,
};

export default weatherRegionActions;
